import React, { FunctionComponent } from 'react';
import AuthPages from './pages';
import type { RouteProps } from 'react-router';

const AuthSubapp: FunctionComponent<RouteProps> = (props) => {
  return <AuthPages />;
};

export default AuthSubapp;
